export default "__VITE_ASSET__Ce7zNDNU__"